import React from "react";
import { openChatbot } from "@widgets/floatingIcon";
import { resolvePath } from "@utils/resolvePath";
import { HelpButton, HelpIconImage, HelpLabel } from "./styles";

const HELP_ICON_SRC = "/images/dashcam/help_headphone.svg";

const HeaderHelpIcon = () => {
  const handleClick = () => {
    openChatbot();
  };

  return (
    <HelpButton type="button" aria-label="Help" onClick={handleClick}>
      <HelpIconImage src={resolvePath(HELP_ICON_SRC)} alt="" />
      <HelpLabel>Help</HelpLabel>
    </HelpButton>
  );
};

export default HeaderHelpIcon;
